import script from "./TransporterFormModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransporterFormModal.vue?vue&type=script&setup=true&lang=ts"

import "./TransporterFormModal.vue?vue&type=style&index=0&id=3106f248&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3106f248"]])

export default __exports__